import { FaSpinner } from 'react-icons/fa';
import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useWorkstationRegistration from './hooks/useWorkstationRegistration';
import { Title, Subtitle, ButtonSubmit, Col, ButtonLink } from './styles';

const LoginWorkstationRegister = ({ values, setCurrentStep, steps, auth }) => {
  const [t] = useTranslation('login');
  const {
    submitting,
    error,
    scope,
    handleRegister,
  } = useWorkstationRegistration({
    email: values.email,
    partnerContextId: values.partnerContextId,
    condominiumContextId: values.condominiumContextId,
    auth,
    setCurrentStep,
    steps,
  });

  return (
    <Col>
      <Title>{t(`workstation.${scope}.title`)}</Title>
      <Subtitle>{t(`workstation.${scope}.subtitle`)}</Subtitle>
      <ButtonSubmit
        block
        color="primary"
        onClick={handleRegister}
        loading={submitting ? 1 : 0}
        disabled={submitting}
      >
        {t(`workstation.${scope}.${submitting ? 'submitting' : 'cta'}`)}
        {submitting && <FaSpinner color="#FFF" size={14} />}
      </ButtonSubmit>
      {error && <Subtitle>{error}</Subtitle>}
      <ButtonLink color="link" onClick={() => setCurrentStep(steps.email)}>
        {t(`workstation.${scope}.back`)}
      </ButtonLink>
    </Col>
  );
};

export default LoginWorkstationRegister;

LoginWorkstationRegister.propTypes = {
  values: propTypes.object.isRequired,
  setCurrentStep: propTypes.func.isRequired,
  steps: propTypes.object.isRequired,
  auth: propTypes.object.isRequired,
};
